(function () {
  function init(btn) {
    if (btn.dataset.buyNowInit === '1') return;
    btn.dataset.buyNowInit = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var labelEl = btn.querySelector('[data-buy-now-text]');
      var originalLabel = labelEl ? labelEl.textContent : '';
      var formId = btn.dataset.productFormId;
      var form = formId ? document.getElementById(formId) : null;
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var variantId = (idInput && idInput.value) || btn.dataset.variantId;
      if (!variantId) return;
      btn.setAttribute('disabled', 'disabled');
      if (labelEl) labelEl.textContent = 'Processing…';
      var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
      var quantity = (quantityInput && parseInt(quantityInput.value, 10)) || 1;
      var properties = {};
      if (form) {
        form.querySelectorAll('[name^="properties["]').forEach(function (el) {
          var key = el.name.match(/properties\[([^\]]+)\]/);
          if (key && el.value) properties[key[1]] = el.value;
        });
      }
      var payload = { id: variantId, quantity: quantity };
      if (Object.keys(properties).length) payload.properties = properties;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, data: d }; });
        })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && res.data.description) || 'Add to cart failed');
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          if (labelEl) labelEl.textContent = 'Try again';
          btn.removeAttribute('disabled');
          setTimeout(function () {
            if (labelEl) labelEl.textContent = originalLabel;
          }, 1800);
        });
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-buy-now]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
